<template>
  <div>
      <div v-for="(item, index) in dadosFichaTecnica" :key="index">
        <div class="grid-row">
          <div class="titulo-grid mt-1 celula-informacao" v-b-toggle="'collapse-' + index" variant="primary">
            {{ item.label }}
            <SGPIconComponent
                icon="mdi-chevron-down-circle"
                class="when-closed float-right"
                color="#444444"
                v-if="dadosFichaTecnica"
              />
              <SGPIconComponent
                icon="mdi-chevron-up-circle"
                class="when-open float-right"
                color="#444444"
                v-if="dadosFichaTecnica"
              />
          </div>
        </div>
        <template v-if="dadosFichaTecnica">
          <b-collapse :id="'collapse-' + index" class="mt-3 mb-2 ml-3">
            <SGPRowComponent>
              <template v-for="(campo) in item">
                <template v-if="typeof campo == 'object'">
                  <template v-for="(i, index) in campo">
                    <span :class="`${index == 'label' ? 'titulo' : ''} col-3 celula-informacao`" cols="3" :key="index"
                      v-if="['label', 'value_label'].includes(index)">
                      {{ i }}
                    </span>
                  </template>
                </template>
              </template>
            </SGPRowComponent>
          </b-collapse>
        </template>
      </div>
  </div>
</template>

<script>

export default {
  name: "PcoCircuitoFichasTecnicasComponent",
  props: {
    dadosFichaTecnica: {
      type: Array,
      required: true
    }
  },
}
</script>

<style scoped>
.celula-informacao {
  padding: 2px 15px;
  margin: 0;
}
</style>